import Joi from 'joi';

export const offerSchema = (t) =>
  Joi.object({
    offerName: Joi.string()
      .required()
      .messages({
        'string.base': t('offer_name_is_required'),
        'string.empty': t('offer_name_is_required'),
      }),
    vendorServiceId: Joi.number().required().messages({
      'number.base': `Service Name cannot be empty'`,
      'number.empty': `Service Name cannot be field`,
    }),
    offerStartDate: Joi.date()
      .required()
      .messages({
        'date.base': t('start_date_is_required'),
        'date.empty': t('start_date_is_required'),
      }),
    offerEndDate: Joi.date()
      .when('offerWithDuration', {
        is: true,
        then: Joi.required(),
        otherwise: Joi.allow(null),
      })
      .messages({
        'date.base': t('end_date_is_required'),
        'date.empty': t('end_date_is_required'),
      }),
    offerWithDuration: Joi.boolean(),
    withPSICommission: Joi.boolean(),
    psiCommissionPercentage: Joi.number()
      .min(0)
      .max(100)
      .when('withPSICommission', {
        is: true,
        then: Joi.required(),
        otherwise: Joi.allow(null),
      })
      .messages({
        'number.base': t('psi_commission_is_required'),
        'number.empty': t('psi_commission_is_required'),
        'number.min': t('psi_commission_cant_be_less_than_0'),
        'number.max': t('psi_commission_cant_be_more_than_100'),
      }),
    offerStatusId: Joi.number()
      .required()
      .messages({
        'number.base': t('offer_status_is_required'),
        'number.empty': t('offer_status_is_required'),
      }),
    vendorServiceCategoryIds: Joi.array()
      .min(1)
      .required()
      .messages({
        'array.base': t('service_category_is_required'),
        'array.empty': t('service_category_is_required'),
        'array.min': t('service_category_is_required'),
      }),
    offerAvailableOn: Joi.number()
      .required()
      .messages({
        'number.base': t('offer_availability_on_is_required'),
        'number.empty': t('offer_availability_on_is_required'),
      }),
    discountPercentage: Joi.number()
      .min(0)
      .max(100)
      .required()
      .messages({
        'number.base': t('discount_percentage_is_required'),
        'number.empty': t('discount_percentage_is_required'),
        'number.min': t('discount_percentage_cant_be_less_than_0'),
        'number.max': t('discount_percentage_cant_be_more_than_100'),
      }),
    discountType: Joi.number()
      .required()
      .messages({
        'number.base': t('discount_type_is_required'),
        'number.empty': t('discount_type_is_required'),
      }),
    vendorAgreementId: Joi.number()
      .required()
      .custom((value, helpers) => {
        const activeItem = helpers.state.ancestors[0];
        if (
          activeItem?.vendorAgreementDetails?.agreementStatus &&
          ['expired', 'terminated', 'inactive'].includes(
            activeItem?.vendorAgreementDetails?.agreementStatus?.agreementStatusName?.toLowerCase()
          )
        ) {
          return helpers.error('any.custom', {
            message: 'please-select-an-active-agreement',
          });
        }
        return value;
      })
      .messages({
        'number.base': t('associated_agreements_is_required'),
        'number.empty': t('associated_agreements_is_required'),
        'any.custom': t('please-select-an-active-agreement'),
      }),
  }).options({ allowUnknown: true, abortEarly: false });
